import styled from 'styled-components';

import STANDARDDEFAULTSRC from 'assets/logo-tsl.svg';
import buildLogo from 'components/b2b/Logo';
import ColormapInterface from 'shared-types/colormapinterface';
import { colorFilterUsage } from 'stylesheetB2b';
import { STANDARDLOGOKEY, getLogoModel, ALLEXTENSIONS } from 'types/logo/logo';

const TSL_LOGO_WIDTH = '26%';
const logoModel = getLogoModel(STANDARDLOGOKEY, ALLEXTENSIONS, STANDARDDEFAULTSRC);

const TslLogoImg = buildLogo(logoModel);

export const B2bPlaceholder = styled.div<{ colors: ColormapInterface }>`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ colors }) => colors.playerPlaceholderBackground};
`;
B2bPlaceholder.displayName = 'B2bPlaceholder';

export const TslLogo = styled(TslLogoImg)`
  width: ${TSL_LOGO_WIDTH};
  filter: ${colorFilterUsage.tslLogo};
  pointer-events: none;
`;

export const LogoContainer = styled.div`
  width: 30%;
`;
